import { render, staticRenderFns } from "./RevenueByCategoryPage.vue?vue&type=template&id=1df72dc9&scoped=true&"
import script from "./RevenueByCategoryPage.vue?vue&type=script&lang=js&"
export * from "./RevenueByCategoryPage.vue?vue&type=script&lang=js&"
import style0 from "./RevenueByCategoryPage.vue?vue&type=style&index=0&id=1df72dc9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1df72dc9",
  null
  
)

export default component.exports